import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { FlexHorizontal, Spacer } from '@vestaboard/installables'
import React, { useEffect } from 'react'

import { Alert } from '@material-ui/lab'
import { EditableCell } from '../components/EditableCell'
import { ListSystemMessageTemplates_listSystemMessageTemplates_systemMessageTemplates } from '../hooks/__generated__/ListSystemMessageTemplates'
import { ListTab } from '../components/ListTab'
import Mustache from 'mustache'
import { useListSystemMessageTemplates } from '../hooks/useListSystemMessageTemplates'
import { useSaveSystemMessageTemplate } from '../hooks/useSaveSystemMessageTemplate'

const isTemplateValid = (template: string) => {
  try {
    Mustache.parse(template)
    return true
  } catch (error) {
    return false
  }
}

export const Templates = () => {
  const [saveTemplate] = useSaveSystemMessageTemplate()
  const { data, loading, error } = useListSystemMessageTemplates({
    limit: 100
  })
  const [systemMessageTemplates, setSystemMessageTemplates] = React.useState<
    ListSystemMessageTemplates_listSystemMessageTemplates_systemMessageTemplates[]
  >([])

  useEffect(() => {
    if (data) {
      setSystemMessageTemplates(data.listSystemMessageTemplates.systemMessageTemplates)
    }
  }, [data])

  return (
    <Box>
      <FlexHorizontal spaceBetween>
        <Typography variant='h4'>Notifications</Typography>
      </FlexHorizontal>
      <Spacer size='extraLarge' />
      <ListTab activeTab='templates' />
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity='error'>There was an error loading the templates</Alert>
      ) : (
        <TableContainer component={Paper}>
          <Table style={{ minWidth: 1600 }}>
            <TableHead>
              <TableCell style={{ width: 100 }}>Topic</TableCell>
              <TableCell style={{ width: 300 }}>Title</TableCell>
              <TableCell>Message</TableCell>
              <TableCell style={{ width: 400 }}>Deep Link</TableCell>
              <TableCell style={{ width: 200 }}>Call To Action</TableCell>
            </TableHead>
            <TableBody>
              {(systemMessageTemplates || []).map(({ __typename, ...template }) => (
                <TableRow key={template.id}>
                  <TableCell>
                    <Typography color='textSecondary'>{template.id}</Typography>
                  </TableCell>
                  <EditableCell
                    error={!isTemplateValid(template.title || '')}
                    value={template.title}
                    onChange={async title => {
                      setSystemMessageTemplates(prevTemplates =>
                        prevTemplates.map(prevTemplate =>
                          prevTemplate.id === template.id ? { ...prevTemplate, title } : prevTemplate
                        )
                      )
                      if (!isTemplateValid(title)) {
                        return
                      }

                      await saveTemplate({
                        variables: {
                          input: {
                            ...template,
                            title
                          }
                        }
                      })
                    }}
                  />
                  <EditableCell
                    error={!isTemplateValid(template.template || '')}
                    value={template.template}
                    onChange={async templateMessage => {
                      setSystemMessageTemplates(prevTemplates =>
                        prevTemplates.map(prevTemplate =>
                          prevTemplate.id === template.id ? { ...prevTemplate, templateMessage } : prevTemplate
                        )
                      )
                      if (!isTemplateValid(templateMessage)) {
                        return
                      }

                      await saveTemplate({
                        variables: {
                          input: {
                            ...template,
                            template: templateMessage
                          }
                        }
                      })
                    }}
                  />
                  <EditableCell
                    error={!isTemplateValid(template.deepLink || '')}
                    value={template.deepLink || ''}
                    onChange={async deepLink => {
                      setSystemMessageTemplates(prevTemplates =>
                        prevTemplates.map(prevTemplate =>
                          prevTemplate.id === template.id ? { ...prevTemplate, deepLink } : prevTemplate
                        )
                      )
                      if (!isTemplateValid(deepLink)) {
                        return
                      }

                      await saveTemplate({
                        variables: {
                          input: {
                            ...template,
                            deepLink
                          }
                        }
                      })
                    }}
                  />

                  <EditableCell
                    error={!isTemplateValid(template.callToAction || '')}
                    value={template.callToAction || ''}
                    onChange={async callToAction => {
                      setSystemMessageTemplates(prevTemplates =>
                        prevTemplates.map(prevTemplate =>
                          prevTemplate.id === template.id ? { ...prevTemplate, callToAction } : prevTemplate
                        )
                      )

                      if (!isTemplateValid(callToAction)) {
                        return
                      }

                      await saveTemplate({
                        variables: {
                          input: {
                            ...template,
                            callToAction
                          }
                        }
                      })
                    }}
                  />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
